var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { validatedScreen } from "@irati/utils/validation";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { CompanyValuesSelect } from "@irati-web/fields/companyValues";
import getId from "@irati/utils/id";
import { Title, Desc, Teams, EndDate, Share } from "@irati-web/fields/poll";
import Trophy from "@irati-web/fields/trophy";
import tracking from "@irati-tracking/recognition/poll";
import { EVERYONE_OPTION, SPECIFIC_TEAMS_OPTION, SPECIFIC_TEAMS } from "@irati/recognition/constants/share";
import { H3 } from "@irati/ui/src/Headings";
import { DATE_PICKER, INSPIRE } from "./Popup";
import DateWarning from "./shared/DateWarning";
import InspireMe from "./shared/InspireMe";
import CTA from "../shared/CTA";
import { HeaderContainer, Flex, StyledForm, StyledHr } from "./styled/Create";
var CreatePoll = /** @class */ (function (_super) {
    __extends(CreatePoll, _super);
    function CreatePoll() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            submit: null,
            trophyValidationError: false
        };
        _this.handleNext = function () {
            var _a = _this.props, onSubmit = _a.onSubmit, poll = _a.poll;
            var submit = onSubmit();
            if (!poll.trophy) {
                _this.setState({ trophyValidationError: true });
            }
            _this.setState({ submit: submit });
            return submit;
        };
        _this.handleCancel = function () {
            tracking.cancelPoll();
            _this.props.selectScreen(null);
        };
        _this.handleTrophySelect = function (trophy) {
            _this.props.onChange(_this.props.poll, "trophy", trophy);
        };
        _this.handleCustomDate = function () {
            _this.props.selectScreen(DATE_PICKER);
        };
        _this.handleInspire = function () {
            tracking.viewInspirations();
            _this.props.selectScreen(INSPIRE);
        };
        _this.handleShareToggle = function (currentValue, key, _a) {
            var value = _a.value;
            _this.props.onSharingOptionChange(value);
        };
        return _this;
    }
    CreatePoll.prototype.render = function () {
        var _a = this.props, poll = _a.poll, share = _a.share, onChange = _a.onChange, apolloState = _a.apolloState, formatMessage = _a.formatMessage, focusReward = _a.focusReward;
        var _b = this.state, submit = _b.submit, trophyValidationError = _b.trophyValidationError;
        return (React.createElement(React.Fragment, null,
            React.createElement(HeaderContainer, null,
                React.createElement(Flex, null,
                    React.createElement(H3, { tiny: true },
                        React.createElement(FormattedMessage, { id: "recognition.popup.createPoll.create.header" })),
                    React.createElement(InspireMe, { onClick: this.handleInspire }))),
            React.createElement(StyledHr, null),
            React.createElement(StyledForm, null,
                React.createElement(Title, { autoFocus: !focusReward, poll: poll, onChange: onChange }),
                React.createElement(Trophy, { componentToHideOnExpand: function () { return React.createElement(Desc, { poll: poll, onChange: onChange }); }, item: poll, onChange: this.handleTrophySelect }),
                React.createElement(CompanyValuesSelect, { item: poll, onChange: onChange }),
                React.createElement(EndDate, { poll: poll, onChange: onChange, onCustomDate: this.handleCustomDate }),
                React.createElement(DateWarning, { poll: poll }),
                React.createElement(Share, { options: [EVERYONE_OPTION(formatMessage), SPECIFIC_TEAMS_OPTION(formatMessage)], poll: { share: share }, onChange: this.handleShareToggle }),
                share === SPECIFIC_TEAMS && React.createElement(Teams, { poll: poll, onChange: onChange })),
            React.createElement(CTA, { id: getId("submitButton", this.props), onNext: this.handleNext, onCancel: this.handleCancel, load: submit, apolloState: apolloState, trophyValidationError: trophyValidationError })));
    };
    CreatePoll.defaultProps = {
        focusReward: false,
        id: "createPoll"
    };
    return CreatePoll;
}(Component));
export default injectIntl(validatedScreen(CreatePoll, "CreatePoll"));
